import { ErrorStateScheduleEnum } from '../../error-state-schedule.enum';

export enum PanelSettingsProductsEditPricesResolverErrorStateEnum {
    GetProductFailed = ErrorStateScheduleEnum.PanelSettingProductsEditPricesResolverStatesStartIndex,
}
